module.exports = __webpack_public_path__ + "static/img/guaranteeTab.8f1a46c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/guaranteeTab.jpg
// module id = yqGi
// module chunks = 4